import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { StarFillIcon } from 'src/domains/layouts/shared/assets/icons/StarFillIcon';
import { StarOutlineIcon } from 'src/domains/layouts/shared/assets/icons/StarOutlineIcon';
import styled from '@emotion/styled';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { withConfig } from 'src/withConfig';
import { NavMenuVariantType } from 'src/domains/layouts/config/features/types';
import { css, SerializedStyles } from '@emotion/react';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

const setNavigationListItemLink = (variant: NavMenuVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === NavMenuVariantType.SECONDARY) {
        return css`
            display: flex;
            gap: ${theme.star.gap.medium};
            align-items: center;
            padding: ${theme.star.padding.medium} 0;
        `;
    }
    return css`
        display: block;
        padding: 12px 10px 12px 0;
        @media ${theme.star.mediaQuery.largeDesktop} {
            color: ${theme.star.lhsNavigation.txtColorSecondary};
            margin: 8px 0;
            padding: 0 20px 0 0;
            &:hover {
                color: ${theme.star.lhsNavigation.txtColorTertiary};
            }
        }
    `;
};


interface NavigationListItemLinkType {
    isCapitalized: boolean;
    variant: NavMenuVariantType | null;
}

export const NavigationListItemLink = withConfig(theme => styled(Link, { label: 'NavigationListItemLink' })<NavigationListItemLinkType>`
    ${({ variant }): SerializedStyles => setNavigationListItemLink(variant, theme)}
    color: ${theme.star.lhsNavigation.txtColor};
    overflow: hidden;
    position: relative;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${({ isCapitalized }): string => isCapitalized ? 'text-transform: capitalize'
        : `
        text-transform: lowercase; 
        &:first-letter {
            text-transform: uppercase; 
        }
    `};
`);

export const NavigationChevronIconWrapper = withConfig(theme => styled(ChevronIcon, { label: 'NavigationChevronIconWrapper' })`
    bottom: 0;
    fill: currentcolor;
    margin: auto 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 12px;
    @media ${theme.star.mediaQuery.largeDesktop} {
        display: none;
    }
`);

export const NavigationStarFillIconWrapper = withConfig(theme => styled(StarFillIcon, { label: 'NavigationStarFillIconWrapper' })`
    bottom: 0;
    fill: ${theme.star.lhsNavigation.bgColor};
    margin: auto 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 16px;
`);

export const NavigationStarOutlineIconWrapper = withConfig(theme => styled(StarOutlineIcon, { label: 'NavigationStarOutlineIconWrapper' })`
    bottom: 0;
    fill: ${theme.star.lhsNavigation.bgColorSecondary};
    margin: auto 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 16px;
`);

export const NavigationListWrapper = withConfig(theme => styled('nav', { label: 'NavigationListWrapper' })`
    font-size: ${theme.star.fontSize.small};
    line-height: 1.4;
`);

interface NavigationIconWrapperPropsType {
    isStarBoosts: boolean;
}

export const NavigationIconWrapper = withConfig(theme => styled('div', { label: 'NavigationIconWrapper' })<NavigationIconWrapperPropsType>`
    display: flex;
    align-items: center;
    align-self: center;
    svg {
        fill: ${({ isStarBoosts }): string => isStarBoosts === true ? theme.star.lhsNavigation.bgColorTertiary : theme.star.lhsNavigation.txtColor};
    }
`);
